// ** Routes Imports
import AppRoutes from './Apps'
import FormRoutes from './Forms'
import PagesRoutes from './Pages'
import TablesRoutes from './Tables'
import ChartsRoutes from './Charts'
import DashboardRoutes, {LeadRouter, WorkRouter, ReportsRouter} from './Dashboards'
import UiElementRoutes from './UiElements'
import ExtensionsRoutes from './Extensions'
import PageLayoutsRoutes from './PageLayouts'
import { roleUser } from '../../views/apps/ecommerce/utils/utils'

// ** Document title
const TemplateTitle = '%s - Cloodo Admin'

// ** Default Route
let DefaultRoute = '/apps/dashboard/private'
if (roleUser() == 'client'){
  DefaultRoute = '/apps/tickets/all-tickets'
}

// ** Merge Routes
const Routes = [
  ...DashboardRoutes,
  ...AppRoutes,
  ...PagesRoutes,
  ...UiElementRoutes,
  ...ExtensionsRoutes,
  ...PageLayoutsRoutes,
  ...FormRoutes,
  ...TablesRoutes,
  ...ChartsRoutes,
  ...WorkRouter,
  ...LeadRouter,
  ...ReportsRouter
]

export { DefaultRoute, TemplateTitle, Routes }
